import React, { Component } from "react";
import Dialog from "../../../../dialogs/dialog";
import { UploadComponentRef } from "../../../../../utils/globalprovider";
import { V2_recfps } from "../../../../../utils/timecodev2";
import AssetSubtitleList from "./assetsubtitlelist/assetsubtitlelist";
import AssetSubtitleSelection from "./assetsubtitleselection/assetsubtitleselection";

import { apiReadOneAsset, apiSearchSubtitlesAssetsFromProject } from "../../../../../utils/apis";
import "./mergedialog.css"
import { configurations_getDefaultPlayerParams } from "../../../../../utils/configurations";

class MergeDialog extends Dialog
{
  constructor(props) 
  {
    super(props);

    const title = {
        fr:"Fusionner/concaténer des fichiers de sous-titres", 
        en:"Merge ou concatenate subtitles Files",
      };
    this.state.title = title;
    this.state.tobecenter = true;

    this.state.assets = [];

    this.state.buttons = 
    [
      {type:"text", disabled:false,text:{fr:"Fusionner",en:"Merge"},key:"MERGE"},
      {type:"text", disabled:false,text:{fr:"Concaténer",en:"Concatenate"},key:"CONCAT"},
      {type:"back", disabled:false},

      
    ]

    this.assetSelectionRef = React.createRef();

    this.handleButton =  this.handleButton.bind(this);

    this.assetsReadCallback = this.assetsReadCallback.bind(this);
      

    this.onQuit = this.onQuit.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this)
    this.didMount = false;

    this.mode = "CONCAT";

    this.onAdd = this.onAdd.bind (this);
    this.onRemove = this.onRemove.bind (this);

    this.state.liste = [];

    this.fusionReadFirstAssetDone = this.fusionReadFirstAssetDone.bind(this);
    this.fusionReadNextAssetDone = this.fusionReadNextAssetDone.bind(this)
    
  }

  onRemove(index)
  {
    if ((index >=0) && (index < this.state.liste.length))
    {
        var liste  = JSON.parse(JSON.stringify(this.state.liste));
        liste.splice (index,1);
        this.setState ({liste: liste})
    }
  }

  onAdd (index)
  {
    

    if ((index >=0) && (index < this.state.assets.length))
    {
        const asset  = this.state.assets[index];

        if (asset.assubtitlecount < 1) return;
        const newasset = {
            asid: asset.asid,
            astitle: asset.astitle,
            astype: asset.astype,
            assubtitlecount: asset.assubtitlecount,
            start:1,
            end: asset.assubtitlecount
        }

        var newliste = JSON.parse(JSON.stringify(this.state.liste));
        newliste.push (newasset);
        this.setState ({liste: newliste})
    }

  }

  componentDidMount()
  {

    // lecture de la vidéo

    this.didMount=true;
    super.componentDidMount();
    apiSearchSubtitlesAssetsFromProject (this.props.pjid, this.assetsReadCallback)
  }

  assetsReadCallback(datas)
  {
    if (!Array.isArray(datas)) 
      this.onQuit();
    else
    {
        
        this.setState ({assets:datas})
    }
  }

  
  onQuit()
  {
    this.props.onButton("back", null);    
  }

  handleOnChange(index, asset)
  {
    const assets = [...this.state.liste];

    assets[index] = asset;

    this.setState({
        liste: assets
    });    
  }


  handleButton(buttonkey)
  {
    
    if ((buttonkey === "CONCAT") || (buttonkey === "MERGE"))
    {
        this.mode = buttonkey;
        if (this.state.liste.length === 0)
        {
            this.onQuit();
            return;
        }


        // Premiere chose on lit le premier asset
        this.currentAsset = 0;
        apiReadOneAsset ({asid: this.state.liste[0].asid}, this.fusionReadFirstAssetDone);
    }
    else
        this.props.onButton(buttonkey, null);
  }

  addSubtitles(asdatas, start, end)
  {
    const datas = JSON.parse(asdatas);
    if (!("subtitles" in datas)) return;
    if (end > datas.subtitles.length) end = datas.subtitles.length;

    for (var st = start; st<= end; st++)
        this.subtitles.push (datas.subtitles[st-1]);

  }

  fusionReadFirstAssetDone(datas)
  {
    if (datas.ret)
    {
        this.firstAsset = datas;
        this.firstAssetDatas = datas.asdatas;

        this.subtitles = [];
        this.addSubtitles (datas.asdatas, this.state.liste[0].start, this.state.liste[0].end);

        if (this.state.liste.length === 1)
            this.uploadAsset();
        else
        {
            this.currentAsset = 1;
            apiReadOneAsset ({asid: this.state.liste[1].asid}, this.fusionReadNextAssetDone);
        }

    }
    else
        return;
  }

  fusionReadNextAssetDone(datas)
  {
    if (datas.ret)
    {
        
        this.addSubtitles (datas.asdatas, this.state.liste[this.currentAsset].start, this.state.liste[this.currentAsset].end);
        if ((this.state.liste.length-1) === this.currentAsset)
            this.uploadAsset();
        else
        {
            this.currentAsset = this.currentAsset + 1;
            apiReadOneAsset ({asid: this.state.liste[this.currentAsset].asid}, this.fusionReadNextAssetDone);
        }

    }
  }

  uploadAsset()
  {
    console.log ("c'est fini la lecture")

    this.firstAssetDatas = JSON.parse(this.firstAssetDatas);
    if (this.mode === "CONCAT")
      this.firstAssetDatas.subtitles = this.subtitles;
    else
      this.firstAssetDatas.subtitles = this.subtitles.sort((a, b) => a.in - b.in);

    console.log("asset", this.firstAsset)
    console.log("asset datas", this.firstAssetDatas);

    var formulaire  = {};
    formulaire.filename = "Merge subtitles file"


    const memoryFile = new File([JSON.stringify(this.firstAssetDatas)], formulaire.filename, 
    {
    type: "application/json", // MIME type for JSON
    lastModified: new Date().getTime() // Timestamp for the file
    });

    
    formulaire.uploadfile = memoryFile;
    formulaire.asframerate = V2_recfps(this.firstAsset.asnum,this.firstAsset.asden);
    formulaire.asnum = this.firstAsset.asnum;
    formulaire.asden = this.firstAsset.asden;
    formulaire.asviid = this.firstAsset.asviid;
    formulaire.asdropframe = this.firstAsset.asdropframe;
    formulaire.astimecode = this.firstAsset.astimecode;
    formulaire.ascoid = this.firstAsset.ascoid;
    formulaire.asoriid = this.firstAsset.asid;
    formulaire.language = this.firstAsset.aslang;
    formulaire.title = this.firstAsset.astitle;


    formulaire.type = 5; // modified subtitles

    

    UploadComponentRef.current.addUpload(this.props.pjid, formulaire, 55,this.onQuit); 

  }

  render()
  {


    return super.render(
  
      <div style = {{width:700, height: 350}}>

        <div className="mergedialogtop">
            <AssetSubtitleList onAdd = {this.onAdd} assets = {this.state.assets}/>
        </div>
      <div className="mergedialoghorizontalLine"></div>
        <div className="mergedialogbottom">
            <AssetSubtitleSelection onChange = {this.handleOnChange} assets = {this.state.liste} ref ={this.assetSelectionRef} onRemove = {this.onRemove}/>
        </div>
    </div>
    );
  }


}
MergeDialog.defaultProps = 
{ 
    pjid: 0,
}


export default MergeDialog;